var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShipmentBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.3753 2C8.13456 2 7.90526 2.10563 7.74504 2.29033L3.3674 7.33688C3.1483 7.46152 3 7.70118 3 7.97636V8.0912V21.1319V21.2692C3 21.6728 3.319 22 3.7125 22H20.2875C20.681 22 21 21.6728 21 21.2692V11.7324V8.0912V7.97636C21 7.70117 20.8517 7.46152 20.6326 7.33687L16.255 2.29033C16.0947 2.10563 15.8654 2 15.6247 2H8.3753ZM11.1556 7.22319H5.72876L8.75372 3.73602H11.1556V7.22319ZM12.8444 7.22319V3.73602H15.2463L18.2712 7.22319H12.8444ZM4.69575 20.2608V8.98481H19.3043V20.2608H4.69575Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipmentBlack);
export default __webpack_public_path__ + "static/media/ShipmentBlack.8b8c05de620568f52a1be466cca0acb0.svg";
export { ForwardRef as ReactComponent };